import {
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';

import { HttpResponse } from '@angular/common/http';
import { ActivatedRoute, ActivatedRouteSnapshot, Router } from '@angular/router';
import { Observable, catchError, of, throwError } from 'rxjs';
import { AccountPortalAuthService } from '../core/auth/auth.service';
import { environment } from '../environments/environment';
import { CathyService } from '../services/cathy.service';
import { Location } from '@angular/common';

/** Inject With Credentials into the request */
@Injectable()
export class PermissionsInterceptor implements HttpInterceptor {
  private route: ActivatedRoute;

  constructor(
    private _authService: AccountPortalAuthService,
    private _cathyService: CathyService,
    private _activatedRoute: ActivatedRoute,
    private _router: Router,
    private _location: Location
  ) {
    this.route = this._activatedRoute;
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<any> {
    return next.handle(request).pipe(catchError(err => {
      if (err.status === 503) {
        const navigation = this._router.getCurrentNavigation();
        const queryParams = navigation?.extractedUrl?.queryParams || {};

        const queryString = new URLSearchParams(queryParams).toString();
        const segments = this._location.path().split('/');
        const fullRedirectURL = `${segments.join('/')}${queryString ? '?' + queryString : ''}`;

        localStorage.setItem('redirectURL', fullRedirectURL);

        const signInUrl = `${window.location.origin}/sign-in?redirectURL=${encodeURIComponent(fullRedirectURL)}`;
        window.location.href = signInUrl;
        return of(new HttpResponse({ body: {}, status: 200 }));
      }

      if (![401, 403].includes(err.status)) {
        const error = err.error?.message || err.statusText || 'Unknown error occurred';
        return throwError(() => error);
      }

      if ([401, 403].includes(err.status)) {
        const fullRedirectURL = window.location.href
        localStorage.setItem('redirectURL', fullRedirectURL);

        // Redirect to sign-in page with full redirect URL
        const urlTree = this._router.parseUrl(`sign-in?redirectURL=${encodeURIComponent(fullRedirectURL)}`);

        // Fire-and-forget navigation, then complete the stream
        this._router.navigateByUrl(urlTree);
        return of(new HttpResponse({ body: {}, status: 200 }));
      }

      if ([403].includes(+err.status)) {
        const navigation = this._router.getCurrentNavigation();
        const queryParams = navigation?.extractedUrl?.queryParams || {};

        const queryString = new URLSearchParams(queryParams).toString();
        const segments = this._location.path().split('/');
        const fullRedirectURL = `${segments.join('/')}${queryString ? '?' + queryString : ''}`;

        localStorage.setItem('redirectURL', fullRedirectURL);

        const urlTree = this._router.parseUrl(`sign-in?redirectURL=${encodeURIComponent(fullRedirectURL)}`);

        this._router.navigateByUrl(urlTree);
        return of(new HttpResponse({ body: {}, status: 200 }));
      }

      return of(err);
    }));
  }
}


